import { createSvgIcon } from '@mui/material';

export const MayaIcon = createSvgIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    // width='53'
    // height='39'
    // viewBox='0 0 53 39'
    width='46'
    height='30'
    viewBox='0 0 46 30'
    fill='none'
  >
    <g filter='url(#filter0_dd_19685_71141)'>
      <rect x='8' y='4' width='37.2537' height='24' rx='4.29851' fill='black' />
      <rect
        x='7.91045'
        y='3.91045'
        width='37.4328'
        height='24.1791'
        rx='4.38806'
        stroke='#D6DCE5'
        strokeWidth='0.179104'
      />
      <g clip-path='url(#clip0_19685_71141)'>
        <mask
          id='mask0_19685_71141'
          style={{ maskType: 'luminance' }}
          maskUnits='userSpaceOnUse'
          x='13'
          y='13'
          width='28'
          height='8'
        >
          <path
            d='M40.4762 13.0459H13.1499V20.9029H40.4762V13.0459Z'
            fill='white'
          />
        </mask>
        <g mask='url(#mask0_19685_71141)'>
          <path
            d='M19.1814 13.0459C18.5522 13.0457 17.9479 13.2918 17.4978 13.7316L17.7418 14.1952L17.6417 14.2757C17.4303 13.9094 17.1273 13.6043 16.7624 13.3904C16.3975 13.1766 15.9833 13.0612 15.5604 13.0557C14.233 13.0557 13.1593 14.2171 13.1593 15.5787V18.5068C13.1583 18.5317 13.1625 18.5566 13.1715 18.5799C13.1806 18.6031 13.1944 18.6243 13.2121 18.6419C13.2297 18.6596 13.2509 18.6734 13.2741 18.6825C13.2974 18.6915 13.3223 18.6957 13.3472 18.6946H14.3086C14.3321 18.695 14.3554 18.6906 14.3772 18.6818C14.3989 18.6729 14.4187 18.6598 14.4353 18.6432C14.4519 18.6266 14.465 18.6068 14.4738 18.5851C14.4827 18.5633 14.4871 18.54 14.4867 18.5165V15.547C14.4867 14.8711 14.8967 14.3269 15.5945 14.3269C16.246 14.3269 16.7121 14.8149 16.7121 15.5348V17.9748C16.7104 17.999 16.7137 18.0233 16.7218 18.0462C16.7298 18.069 16.7424 18.09 16.7589 18.1079C16.7753 18.1257 16.7953 18.1399 16.8174 18.1498C16.8396 18.1596 16.8635 18.1649 16.8878 18.1652H17.7979C17.8221 18.1649 17.8461 18.1596 17.8682 18.1498C17.8904 18.1399 17.9103 18.1257 17.9268 18.1079C17.9432 18.09 17.9559 18.069 17.9639 18.0462C17.972 18.0233 17.9752 17.999 17.9736 17.9748V15.5348C17.9628 15.3789 17.9844 15.2226 18.0371 15.0755C18.0898 14.9285 18.1724 14.7939 18.2797 14.6804C18.387 14.5669 18.5167 14.4769 18.6606 14.4161C18.8044 14.3552 18.9594 14.3249 19.1155 14.3269C19.811 14.3269 20.1989 14.8808 20.1989 15.547V18.5116C20.2008 18.56 20.2215 18.6056 20.2566 18.6389C20.2917 18.6722 20.3384 18.6904 20.3868 18.6898H21.3384C21.3635 18.6912 21.3885 18.6873 21.412 18.6783C21.4354 18.6694 21.4567 18.6556 21.4744 18.6379C21.4922 18.6202 21.506 18.5989 21.5149 18.5754C21.5239 18.552 21.5277 18.5269 21.5263 18.5019V15.5738C21.5263 14.2074 20.4991 13.0459 19.1814 13.0459Z'
            fill='#75EEA5'
          />
          <path
            d='M27.8019 13.1552H26.9284C26.9041 13.1535 26.8797 13.1569 26.8568 13.1651C26.8339 13.1733 26.813 13.1862 26.7953 13.203C26.7776 13.2197 26.7636 13.24 26.7542 13.2624C26.7448 13.2848 26.7401 13.309 26.7405 13.3333V13.4529L27.0504 13.9409L26.965 14.0239C26.7092 13.7223 26.3917 13.4792 26.0339 13.3108C25.6761 13.1424 25.2863 13.0527 24.8909 13.0479C24.1539 13.0828 23.4584 13.3997 22.9483 13.9329C22.4383 14.4661 22.1526 15.175 22.1504 15.9129C22.1482 16.6508 22.4296 17.3614 22.9365 17.8976C23.4434 18.4339 24.137 18.7549 24.8739 18.7942C25.2711 18.79 25.6629 18.7006 26.0228 18.5323C26.3826 18.3639 26.7022 18.1204 26.9601 17.8182L27.0333 17.8767L26.7234 18.3843V18.4965C26.7231 18.5213 26.7277 18.5459 26.7371 18.5688C26.7464 18.5918 26.7602 18.6126 26.7777 18.6301C26.7952 18.6476 26.8161 18.6614 26.839 18.6708C26.862 18.6801 26.8866 18.6847 26.9113 18.6844H27.8019C27.827 18.6858 27.852 18.6819 27.8755 18.673C27.8989 18.6641 27.9202 18.6502 27.9379 18.6325C27.9557 18.6148 27.9695 18.5935 27.9784 18.5701C27.9874 18.5466 27.9912 18.5216 27.9898 18.4965V13.3333C27.991 13.3088 27.9869 13.2843 27.9777 13.2615C27.9685 13.2387 27.9546 13.2181 27.9367 13.2012C27.9189 13.1843 27.8976 13.1714 27.8744 13.1635C27.8511 13.1555 27.8264 13.1527 27.8019 13.1552ZM24.8739 17.5595C24.4396 17.5595 24.0232 17.387 23.7161 17.08C23.4091 16.7729 23.2366 16.3565 23.2366 15.9222C23.2366 15.488 23.4091 15.0716 23.7161 14.7645C24.0232 14.4575 24.4396 14.285 24.8739 14.285C25.3081 14.285 25.7245 14.4575 26.0316 14.7645C26.3386 15.0716 26.5111 15.488 26.5111 15.9222C26.5111 16.3565 26.3386 16.7729 26.0316 17.08C25.7245 17.387 25.3081 17.5595 24.8739 17.5595Z'
            fill='#75EEA5'
          />
          <path
            d='M40.2858 13.1552H39.4123C39.3881 13.1535 39.3637 13.1569 39.3407 13.1651C39.3178 13.1733 39.2969 13.1862 39.2793 13.203C39.2616 13.2197 39.2476 13.24 39.2381 13.2624C39.2287 13.2848 39.224 13.309 39.2244 13.3333V13.4529L39.5343 13.9409L39.4489 14.0239C39.1931 13.7223 38.8755 13.4792 38.5178 13.3108C38.16 13.1424 37.7702 13.0527 37.3749 13.0479C36.6119 13.0479 35.8802 13.3509 35.3407 13.8905C34.8011 14.43 34.498 15.1617 34.498 15.9247C34.498 16.6877 34.8011 17.4194 35.3407 17.9589C35.8802 18.4984 36.6119 18.8015 37.3749 18.8015C37.7721 18.7973 38.1639 18.7079 38.5237 18.5396C38.8835 18.3712 39.2032 18.1277 39.461 17.8255L39.5343 17.8841L39.2244 18.3916V18.5038C39.224 18.5286 39.2287 18.5532 39.238 18.5761C39.2474 18.5991 39.2612 18.6199 39.2787 18.6374C39.2962 18.6549 39.317 18.6688 39.3401 18.6781C39.363 18.6874 39.3875 18.6921 39.4123 18.6917H40.2858C40.3109 18.6931 40.336 18.6892 40.3594 18.6803C40.3829 18.6714 40.4041 18.6576 40.4218 18.6398C40.4396 18.6221 40.4534 18.6008 40.4623 18.5774C40.4713 18.554 40.4752 18.5289 40.4737 18.5038V13.3333C40.475 13.3088 40.4707 13.2843 40.4616 13.2615C40.4525 13.2387 40.4385 13.2181 40.4207 13.2012C40.4028 13.1843 40.3816 13.1714 40.3583 13.1635C40.3351 13.1555 40.3103 13.1527 40.2858 13.1552ZM37.3749 17.5595C36.9407 17.5595 36.5241 17.387 36.2171 17.08C35.9101 16.7729 35.7375 16.3565 35.7375 15.9222C35.7375 15.488 35.9101 15.0716 36.2171 14.7645C36.5241 14.4575 36.9407 14.285 37.3749 14.285C37.8091 14.285 38.2255 14.4575 38.5327 14.7645C38.8396 15.0716 39.0121 15.488 39.0121 15.9222C39.0121 16.3565 38.8396 16.7729 38.5327 17.08C38.2255 17.387 37.8091 17.5595 37.3749 17.5595Z'
            fill='#75EEA5'
          />
          <path
            d='M33.78 13.1555H32.8845C32.7405 13.1555 32.6626 13.2336 32.6626 13.3092V16.0104C32.6752 16.1992 32.6477 16.3886 32.5818 16.5661C32.516 16.7435 32.4133 16.905 32.2804 17.0399C32.1476 17.1747 31.9878 17.2799 31.8114 17.3485C31.6351 17.4171 31.446 17.4476 31.257 17.4378C30.4713 17.4378 29.9638 16.8522 29.9638 16.0104V13.3092C29.9638 13.2336 29.8418 13.1555 29.7637 13.1555H28.7877C28.748 13.1588 28.7108 13.1761 28.6827 13.2042C28.6546 13.2324 28.6373 13.2696 28.634 13.3092V15.9933C28.6261 16.6949 28.8964 17.3711 29.3856 17.874C29.8748 18.377 30.5433 18.6658 31.2448 18.6774C31.9152 18.678 32.5627 18.4332 33.0652 17.9893L33.1164 18.0356L32.7186 18.5773V18.7945C32.7186 19.3484 31.8866 19.6583 31.401 19.6583H31.0911C31.0662 19.6566 31.0413 19.66 31.0177 19.668C30.9941 19.6761 30.9724 19.6888 30.9538 19.7054C30.9351 19.722 30.92 19.7421 30.9092 19.7646C30.8984 19.7871 30.8923 19.8115 30.891 19.8364V20.7197C30.8954 20.7693 30.9185 20.8154 30.9557 20.8485C30.9929 20.8816 31.0413 20.8993 31.0911 20.8978H31.401C32.8845 20.8978 33.9679 20.0341 33.9679 18.4065V13.3092C33.9614 13.2648 33.9385 13.2245 33.9037 13.1961C33.8689 13.1677 33.8248 13.1532 33.78 13.1555Z'
            fill='#75EEA5'
          />
        </g>
      </g>
    </g>
    <defs>
      <filter
        id='filter0_dd_19685_71141'
        x='0.656622'
        y='0.238711'
        width='51.9402'
        height='38.6868'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='0.358209' />
        <feGaussianBlur stdDeviation='1.79104' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_19685_71141'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='3.58209' />
        <feGaussianBlur stdDeviation='3.58209' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0 0.717647 0 0 0 0.08 0'
        />
        <feBlend
          mode='normal'
          in2='effect1_dropShadow_19685_71141'
          result='effect2_dropShadow_19685_71141'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect2_dropShadow_19685_71141'
          result='shape'
        />
      </filter>
      <clipPath id='clip0_19685_71141'>
        <rect
          width='27.5349'
          height='8'
          fill='white'
          transform='translate(13 13)'
        />
      </clipPath>
    </defs>
  </svg>,
  'MayaIcon',
);
